import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled", "optional", "required", "size"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { LabelMixin } from '../../mixins/components/LabelMixin';
import { LABEL_SIZES } from '../../constants/LABEL';
import { FormFieldContext } from '../../js/FormFieldContext';
export var StyledLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "StyledLabel",
  componentId: "c11n-8-64-0__sc-qq9hfi-0"
})(["", ""], LabelMixin);
var defaultProps = {
  size: LABEL_SIZES.md
};
/**
 * A native HTML [`<label>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label).
 */

var Label = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _defaultProps$props = Object.assign({}, defaultProps, props),
      disabled = _defaultProps$props.disabled,
      optional = _defaultProps$props.optional,
      required = _defaultProps$props.required,
      size = _defaultProps$props.size,
      rest = _objectWithoutProperties(_defaultProps$props, _excluded);

  var merged = Object.assign({}, defaultProps, React.useContext(FormFieldContext), props);
  return /*#__PURE__*/React.createElement(StyledLabel, _extends({
    ref: ref,
    id: merged.labelId,
    htmlFor: merged.controlId,
    "data-required": merged.required,
    "data-optional": merged.optional,
    "aria-disabled": merged.disabled,
    size: merged.size
  }, rest));
});
Label.displayName = 'Label';
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Sets the native id attribute.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  id: PropTypes.string,

  /**
   * Sets the
   * [`for`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#Attributes)
   * attribute of the label, associating the label with a form control.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  htmlFor: PropTypes.string,

  /**
   * Mark the field as required.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  required: PropTypes.bool,

  /**
   * Mark the field as disabled.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the field as optional.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   */
  optional: PropTypes.bool,

  /**
   * The size of the label.
   * Can be controlled by [`FormField`](#/Form%20components?id=formfield) context.
   *
   * @since 6.7.0
   */
  size: PropTypes.oneOf(Object.keys(LABEL_SIZES))
} : {};
export default Label;